module.exports = {
  apolloLineHeightHeading6: "1rem",
  apolloLineHeightDisplayData: "1rem",
  apolloTextTransformEyebrowSmall: "uppercase",
  apolloFontStyleDisplaySmall: "normal",
  apolloFontFamilyHeading4: "Inter",
  apolloFontStyleSubStrong: "normal",
  apolloFontSizeDisplayData: "0.75rem",
  apolloFontFamilyHeading5: "Inter",
  apolloFontWeightCode: 400,
  apolloFontFamilyButtonLabel: "Inter",
  apolloFontFamilyPill: "Inter",
  apolloTextTransformHeaderSecondaryTitle: "uppercase",
  apolloFontFamilyHeading6: "Inter",
  apolloFontSizeBodyXlarge: "1rem",
  apolloLineHeightBodyXlarge: "1.5rem",
  apolloFontStyleCodeSmall: "normal",
  apolloFontSizeHeading2Light: "2rem",
  apolloFontStyleSub: "normal",
  apolloSpaceStack1HalfX: "12px",
  apolloLineHeightPill: "1rem",
  apolloLineHeightButtonLabel: "0.5rem",
  apolloLineHeightHeading2Light: "2.5rem",
  apolloFontSizePill: "0.6875rem",
  apolloFontWeightVerySmall: 500,
  apolloFontFamilyBodyXlarge: "Inter",
  apolloFontSizeButtonLabel: "0.6875rem",
  apolloFontFamilyBodySmall: "Inter",
  apolloFontStyleDisplay: "normal",
  apolloFontStyleBodyStrong: "normal",
  apolloFontWeightDisplaySmall: 600,
  apolloFontFamilyHeading2Light: "Inter",
  apolloLineHeightBodySmall: "1rem",
  apolloFontStyleEyebrowSmall: "normal",
  apolloFontStyleHeaderMainTitle: "normal",
  apolloZindexDropdown: 500,
  apolloFontFamilyHeaderSecondaryTitle: "Inter",
  apolloFontSizeBodySmall: "0.75rem",
  apolloSpaceStackHalfX: "4px",
  apolloSpaceInline1HalfX: "12px",
  apolloLetterSpacingDisplaySmall: "-0.0625rem",
  apolloFontStyleCode: "normal",
  apolloLineHeightHeaderSecondaryTitle: "0.75rem",
  apolloFontStyleHeading1: "normal",
  apolloFontFamilyRibbonTitle: "Inter",
  apolloFontWeightDisplayData: 500,
  apolloFontWeightSub: 400,
  apolloFontSizeHeaderSecondaryTitle: "0.625rem",
  apolloFontStyleHeading2: "normal",
  apolloFontStyleBodyEmphasis: "italic",
  apolloFontFamilyBody: "Inter",
  apolloFontStyleBodySmallStrong: "normal",
  apolloZindexTooltip: 1000,
  apolloFontFamilyTileDisplay: "Inter",
  apolloLineHeightRibbonTitle: "2rem",
  apolloSpaceStack6X: "48px",
  apolloFontStyleVerySmall: "normal",
  apolloFontStyleHeading3: "normal",
  apolloSpaceInlineHalfX: "4px",
  apolloFontWeightBodyStrong: 600,
  apolloFontFamilySubStrong: "Inter",
  apolloFontWeightDisplay: 600,
  apolloFontSizeRibbonTitle: "1.0625rem",
  apolloSpaceStack5X: "40px",
  apolloFontStyleHeading4: "normal",
  apolloLineHeightBody: "1rem",
  apolloFontWeightPill: 600,
  apolloFontSizeBody: "0.75rem",
  apolloSpaceStack4X: "32px",
  apolloFontWeightButtonLabel: 600,
  apolloFontStyleHeading5: "normal",
  apolloFontWeightEyebrowSmall: 600,
  apolloLineHeightTileDisplay: "1.5rem",
  apolloLetterSpacingDisplay: "-0.0625rem",
  apolloLineHeightSubStrong: "1rem",
  apolloSpaceStack3X: "24px",
  apolloFontStyleHeading6: "normal",
  apolloSpaceInset1HalfX: "12px",
  apolloFontWeightHeaderMainTitle: 600,
  apolloFontSizeTileDisplay: "1.5rem",
  apolloFontSizeSubStrong: "0.6875rem",
  apolloSpaceStack2X: "16px",
  apolloFontSizeDisplaySmall: "1.25rem",
  apolloZindexDialogOverlay: 1500,
  apolloFontFamilyCodeSmall: "Fira Code",
  apolloFontWeightBodySmall: 400,
  apolloFontWeightHeading1: 400,
  apolloSpaceStack1X: "8px",
  apolloSpaceInline6X: "48px",
  apolloLineHeightDisplaySmall: "1.5rem",
  apolloFontStyleDisplayData: "normal",
  apolloLetterSpacingHeaderMainTitle: "-0.02500000037252903rem",
  apolloFontWeightHeading2: 400,
  apolloSpaceInline5X: "40px",
  apolloFontWeightBodyEmphasis: 400,
  apolloLineHeightCodeSmall: "1rem",
  apolloFontStyleBodyXlarge: "normal",
  apolloFontFamilyDisplaySmall: "Inter",
  apolloFontWeightHeading3: 600,
  apolloSpaceInline4X: "32px",
  apolloSpaceInsetHalfX: "4px",
  apolloFontSizeCodeSmall: "0.75rem",
  apolloFontWeightBodySmallStrong: 600,
  apolloFontWeightHeaderSecondaryTitle: 600,
  apolloSpaceInline3X: "24px",
  apolloFontWeightHeading4: 600,
  apolloFontSizeSub: "0.6875rem",
  apolloFontStyleHeading2Light: "normal",
  apolloSpaceInline2X: "16px",
  apolloFontWeightHeading5: 500,
  apolloFontStyleButtonLabel: "normal",
  apolloFontStylePill: "normal",
  apolloLineHeightSub: "1rem",
  apolloLetterSpacingHeading3: "-0.02500000037252903rem",
  apolloFontWeightRibbonTitle: 400,
  apolloFontSizeBodyStrong: "0.75rem",
  apolloSpaceInline1X: "8px",
  apolloLetterSpacingTileDisplay: "-0.0625rem",
  apolloFontWeightHeading6: 600,
  apolloFontSizeDisplay: "1.5rem",
  apolloFontFamilyCode: "Fira Code",
  apolloFontSizeEyebrowSmall: "0.625rem",
  apolloFontWeightBody: 400,
  apolloLineHeightBodyStrong: "1rem",
  apolloLineHeightDisplay: "2rem",
  apolloSpaceInset6X: "48px",
  apolloFontFamilySub: "Inter",
  apolloLineHeightEyebrowSmall: "0.625rem",
  apolloFontSizeHeaderMainTitle: "1rem",
  apolloFontStyleBodySmall: "normal",
  apolloFontWeightTileDisplay: 600,
  apolloSpaceInset5X: "40px",
  apolloLineHeightCode: "1rem",
  apolloFontFamilyVerySmall: "Inter",
  apolloLineHeightHeaderMainTitle: "1.25rem",
  apolloFontSizeCode: "0.8125rem",
  apolloFontWeightSubStrong: 600,
  apolloFontFamilyDisplay: "Inter",
  apolloSpaceInset4X: "32px",
  apolloFontFamilyBodyStrong: "Inter",
  apolloFontWeightBodyXlarge: 400,
  apolloFontFamilyEyebrowSmall: "Inter",
  apolloSpaceInset3X: "24px",
  apolloFontSizeHeading1: "2.5rem",
  apolloLineHeightHeading1: "3rem",
  apolloFontStyleHeaderSecondaryTitle: "normal",
  apolloFontWeightHeading2Light: 300,
  apolloFontFamilyHeaderMainTitle: "Inter",
  apolloSpaceInset2X: "16px",
  apolloLineHeightVerySmall: "0.75rem",
  apolloFontSizeHeading2: "2rem",
  apolloFontSizeBodyEmphasis: "0.75rem",
  apolloLineHeightHeading2: "2.5rem",
  apolloFontWeightCodeSmall: 400,
  apolloFontSizeBodySmallStrong: "0.75rem",
  apolloSpaceInset1X: "8px",
  apolloFontSizeHeading3: "1rem",
  apolloFontSizeVerySmall: "0.5625rem",
  apolloLineHeightBodyEmphasis: "1rem",
  apolloLineHeightHeading3: "1.5rem",
  apolloFontStyleRibbonTitle: "normal",
  apolloLineHeightBodySmallStrong: "1rem",
  apolloFontFamilyHeading1: "Inter",
  apolloFontSizeHeading4: "0.875rem",
  apolloLineHeightHeading4: "1rem",
  apolloFontFamilyBodyEmphasis: "Inter",
  apolloFontFamilyDisplayData: "Inter",
  apolloFontFamilyHeading2: "Inter",
  apolloFontStyleBody: "normal",
  apolloFontSizeHeading5: "0.8125rem",
  apolloLineHeightHeading5: "1rem",
  apolloFontFamilyBodySmallStrong: "Inter",
  apolloFontStyleTileDisplay: "normal",
  apolloFontFamilyHeading3: "Inter",
  apolloFontSizeHeading6: "0.75rem",
  apolloZindexDialog: 2000,
  apolloThemes: {
    light: {
      "apolloBoxShadowDropdownMenu": "0px 2px 8px rgba(139, 147, 166, 0.32)",
      "apolloBoxShadowSeparatorBottom": "inset 0px -1px 0px rgba(228, 230, 241, 1)",
      "apolloColorStrokeButtonPrimarySeparatorDefault": "#3d98cf",
      "apolloBoxShadowSeparatorTop": "inset 0px 1px 0px rgba(228, 230, 241, 1)",
      "apolloColorBackgroundMiniTagDisabled": "#f5f6fa",
      "apolloColorBackgroundButtonTertiaryFocus": "#ffffff",
      "apolloColorTextDisabledOnLight": "#a8aebc",
      "apolloColorTextPrimaryOnDark": "#ffffff",
      "apolloColorBackgroundContainerSideHighlight": "#163350",
      "apolloBoxShadowFormElementCheckedDisabled": "0px 1px 0px rgba(139, 147, 166, 0.08)",
      "apolloColorStrokeMessageInfo": "#d9eaf5",
      "apolloColorVizGreenLineBackground": "linear-gradient(180deg, rgba(119, 194, 151, 0.2) 0%, rgba(119, 194, 151, 0) 100%)",
      "apolloColorFillCalendarSelectedEdge": "#08568a",
      "apolloBoxShadowPanelScrolled": "inset 0px 1px 0px rgba(139, 147, 166, 0.24)",
      "apolloColorBackgroundDialogOverlay": "rgba(88, 98, 125, 0.5)",
      "apolloColorBackgroundBetaTag": "#d8dcea",
      "apolloColorTextPopoverPrimary": "#ffffff",
      "apolloColorStrokeFormElementDefault": "#647893",
      "apolloColorVizYellow": "#fdcd6c",
      "apolloColorBackgroundCollectionSelectorCategory": "#f5f6fa",
      "apolloColorStrokeFocusOnDark": "#ffffff",
      "apolloColorBackgroundMiniTagNeutral": "#d9eaf5",
      "apolloColorStrokePopoverFocus": "#ffffff",
      "apolloColorVizRed": "#ec6054",
      "apolloColorBackgroundButtonSecondaryActive": "#d1d4dd",
      "apolloColorVizValue": "#708dbe",
      "apolloColorVizMapMarkerRedDefault": "rgba(240, 126, 110, 0.72)",
      "apolloColorBackgroundFormElementFocus": "#ffffff",
      "apolloColorVizBackgroundLightSelected": "#f1ecc8",
      "apolloBoxShadowPopoverFocus": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorStrokeMapMarkerHoverFocus": "#ffffff",
      "apolloColorFillScrollbar": "rgba(139, 147, 166, 0.5)",
      "apolloColorTextMiniTagNeutral": "#58627d",
      "apolloColorBackgroundHeader": "#ffffff",
      "apolloColorBackgroundCalendarHover": "#c4c9d4",
      "apolloColorStrokeFilterDisabled": "#d8dcea",
      "apolloColorFillFormElementSelectedDisabled": "#91b0cc",
      "apolloColorTextBullet1stLevel": "#a7cde7",
      "apolloColorStrokeInteractiveTagDefault": "#647893",
      "apolloBoxShadowHeader1stLevelSelected": "inset 1px 0px 0px rgba(250, 251, 253, 1), inset -1px 0px 0px rgba(250, 251, 253, 1)",
      "apolloColorBackgroundButtonSecondaryDefault": "#ffffff",
      "apolloColorBackgroundButtonTertiaryHover": "#f1f7fc",
      "apolloColorFillFormElementSelected": "#08568a",
      "apolloColorStrokeFilter": "#f4e8cc",
      "apolloColorBackgroundCollectionSelectorObjectSelected": "#4f82ae",
      "apolloColorTextVizGreen": "#377b56",
      "apolloColorBackgroundHover": "#f5f6fa",
      "apolloBoxShadowDragged": "0px 4px 4px rgba(39, 45, 54, 0.16)",
      "apolloColorBackgroundFormElementCheckedDefault": "#ffffff",
      "apolloColorBackgroundTopNav2ndLevelSelected": "#e4e6f1",
      "apolloColorVizGreenBackground": "#9dd3b4",
      "apolloColorBackgroundVizGreen": "#edf7ee",
      "apolloColorBackgroundMainNavMenuHover": "#f1f7fc",
      "apolloColorVizYellowThresholdBandBackground": "#fffcf2",
      "apolloColorBackgroundMainNavBarItemHover": "#1b4064",
      "apolloColorVizSelectionStroke": "#5da8ec",
      "apolloColorBackgroundFormElementHover": "#ffffff",
      "apolloColorFillCalendarSelected": "#a7cde7",
      "apolloBoxShadowFormElementChecked": "0px 1px 0px rgba(139, 147, 166, 0.08)",
      "apolloBoxShadowRightPanelIssueSelected": "inset 4px 0px 0px rgba(45, 106, 159, 1)",
      "apolloColorStrokeToggleDisabled": "#d8dcea",
      "apolloBoxShadowTabSelectedTop": "inset 0px 2px 0px rgba(45, 106, 159, 1)",
      "apolloColorStrokeSelected": "#5da8ec",
      "apolloColorVizValue2": "#a3537c",
      "apolloColorVizRedThresholdBandBackground": "#fef2f1",
      "apolloColorBackgroundMainNavBar": "#0c5497",
      "apolloColorStrokeMessageWarning": "#f1ecc8",
      "apolloColorBackgroundButtonPrimaryFocus": "#0c6fc6",
      "apolloBoxShadowFormElementOpen": "inset 0px 1px 0px rgba(139, 147, 166, 0.24)",
      "apolloColorStrokeButtonTertiaryDisabled": "#e4e6f1",
      "apolloColorBackgroundNumbered1stLevel": "#f1f7fc",
      "apolloColorStrokeFormElementOpen": "#e4e6f1",
      "apolloColorBackgroundChipHighlighted": "#f1f7fc",
      "apolloColorVizValue3": "#ddd27a",
      "apolloColorVizMapMarkerRedHoverFocus": "rgba(240, 126, 110, 0.8)",
      "apolloColorVizMapMarkerYellowDefault": "rgba(253, 205, 108, 0.72)",
      "apolloColorBackgroundToggleKnob": "#ffffff",
      "apolloColorBackgroundRightPanelItemDefault": "#f5f6fa",
      "apolloColorTextDestructive": "#ca2b16",
      "apolloColorTextNumbered1stLevel": "#4a6aa1",
      "apolloColorTextPrimary": "#272d36",
      "apolloColorBackgroundRightPanel": "#e5e7ee",
      "apolloColorTextTertiary": "#58627d",
      "apolloColorBackgroundSummaryBannerIcon": "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.64) 100%)",
      "apolloColorTextInteractive": "#0c6fc6",
      "apolloColorVizValue4": "#e84d5f",
      "apolloColorBackgroundContainer": "#ffffff",
      "apolloBoxShadowRightPanelItemOpened": "inset 0px 1px 0px rgba(139, 147, 166, 0.4)",
      "apolloColorBackgroundButtonTertiaryDefault": "#ffffff",
      "apolloColorBackgroundMessageInfo": "#f1f7fc",
      "apolloColorBackgroundMenuItemHover": "#eeeff6",
      "apolloColorTextPrimaryOnLight": "#272d36",
      "apolloColorStrokeFocus": "#1c8ef2",
      "apolloColorBackgroundButtonPrimaryDisabled": "#a7cde7",
      "apolloColorTextDisabledOnDark": "#ffffff",
      "apolloColorVizValue5": "#b5bac6",
      "apolloColorBackgroundMessageError": "#fdeae8",
      "apolloColorFillWaiting": "#d8dcea",
      "apolloColorBackgroundTooltip": "#ffffff",
      "apolloColorStrokeRightPanelSeparator": "#d1d4dd",
      "apolloColorStrokeRightPanelSelectedSeparator": "#d8dcea",
      "apolloColorBackgroundMenuItemSelected": "#08568a",
      "apolloColorBackgroundFormElementDefault": "#ffffff",
      "apolloColorBackgroundDialogProtectedArea": "#f5f6fa",
      "apolloColorVizValue6": "#d3b5f5",
      "apolloBoxShadowRightPanelItem": "0px 1px 0px rgba(139, 147, 166, 0.16)",
      "apolloColorStrokeAssistantDecoration": "#c4c9d4",
      "apolloBoxShadowRightPanelSeparator": "inset 1px 0px 0px rgba(209, 212, 221, 1)",
      "apolloColorBackgroundHeaderUnfilteredDefault": "#f5f6fa",
      "apolloColorVizBlueThresholdBandBackground": "#e8edf5",
      "apolloColorBackgroundButtonPrimaryHover": "#0959a3",
      "apolloColorStrokeTableDivider": "#e4e6f1",
      "apolloColorStrokeChipDefault": "#e4e6f1",
      "apolloColorFillColorTagDisabled": "#e4e6f1",
      "apolloColorBackgroundMedia": "#e4e6f1",
      "apolloBoxShadowFormElement": "0px 1px 0px rgba(139, 147, 166, 0.08)",
      "apolloColorVizYellowLineBackground": "linear-gradient(180deg, rgba(253, 205, 108, 0.2) 0%, rgba(253, 205, 108, 0) 100%)",
      "apolloColorBackgroundHeader1stLevel": "#e4e6f1",
      "apolloColorBackgroundContainerSideDefault": "#e8edf5",
      "apolloBoxShadowFormElementFocusHighlight": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorBackgroundPopover": "#272d36",
      "apolloColorStrokeButtonHover": "#272d36",
      "apolloColorBackgroundTableCellSelectedHover": "#f1f7fc",
      "apolloColorStrokeMessageOk": "#d1ead9",
      "apolloColorStrokeHover": "#e4e6f1",
      "apolloColorVizRedLineBackground": "linear-gradient(180deg, rgba(240, 126, 110, 0.2) 0%, rgba(240, 126, 110, 0) 100%)",
      "apolloColorVizPurpleThresholdBandBackground": "#f0e3ea",
      "apolloColorBackgroundHeaderUnfilteredSelected": "#ffffff",
      "apolloColorVizValueLineBackground": "linear-gradient(180deg, rgba(112, 141, 190, 0.2) 0%, rgba(112, 141, 190, 0) 100%)",
      "apolloColorBackgroundFilter": "#fbf8ec",
      "apolloColorBackgroundRightBarBadge": "#58627d",
      "apolloColorFillTableGroupShadow": "linear-gradient(180deg, rgba(202, 205, 219, 0.4) 0%, rgba(228, 230, 241, 0) 100%)",
      "apolloColorVizBenchmark": "#00838e",
      "apolloColorBackgroundFormElementSelected": "#08568a",
      "apolloColorStrokePopoverSeparator": "#383e46",
      "apolloColorBackgroundMenuItemDefault": "#ffffff",
      "apolloColorBackgroundIconButtonHover": "#d8dcea",
      "apolloColorTextRightPanelRank": "#c4c9d4",
      "apolloColorVizMapMarkerYellowHoverFocus": "rgba(253, 205, 108, 0.8)",
      "apolloColorBackgroundMainNavBarItemSelected": "#0c6fc6",
      "apolloBoxShadowFormElementFocusOnDark": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorTextError": "#ec6054",
      "apolloColorBackgroundMiniTagOther1": "#fbdbd7",
      "apolloColorBackgroundRightPanelHeader": "#d8dcea",
      "apolloColorBackgroundFormElementDisabled": "#f5f6fa",
      "apolloColorBackgroundTopNav2ndLevelHover": "#e4e6f1",
      "apolloColorBackgroundContainerHighlight": "#1b4064",
      "apolloColorVizValueStrokeHover": "#6b9fca",
      "apolloColorBackgroundContainerSecondary": "#e8edf5",
      "apolloColorVizRedStrokeHover": "#d87d70",
      "apolloColorVizYellowThresholdBandStroke": "#feebc3",
      "apolloColorTextMiniTagOther1": "#6f4645",
      "apolloColorBackgroundMiniTagOther2": "#fedb95",
      "apolloColorBackgroundIconKpiIcon": "#ffffff",
      "apolloColorTextVizYellow": "#877336",
      "apolloColorBackgroundCollectionSelectorObjectHover": "#ffffff",
      "apolloColorFillFormElementDefaultDisabled": "#e4e6f1",
      "apolloColorBackgroundRightPanelItemSelected": "#8b93a6",
      "apolloColorBackgroundButtonPrimaryDefault": "#0c6fc6",
      "apolloColorVizRedThresholdBandStroke": "#fdeae8",
      "apolloColorVizYellowStrokeHover": "#d3ae64",
      "apolloColorBackgroundHourPicker": "#d8dcea",
      "apolloColorStrokeFocusSecondary": "#272d36",
      "apolloColorTextMiniTagOther2": "#6f4645",
      "apolloColorBackgroundMiniTagOther3": "#d1ead9",
      "apolloColorBackgroundSelected": "#5da8ec",
      "apolloColorStrokeButtonTertiaryActive": "#d9eaf5",
      "apolloColorTextVizRed": "#ca2b16",
      "apolloColorTextVizValue": "#4a6aa1",
      "apolloColorFillScrollbarHover": "#8b93a6",
      "apolloColorBackgroundButtonTertiaryDisabled": "#ffffff",
      "apolloColorVizStackedValue11": "#b5e0f6",
      "apolloColorBackgroundHeaderHover": "#f5f6fa",
      "apolloColorTextMiniTagOther3": "#384746",
      "apolloColorVizNoValueStrokeHover": "#b5bac6",
      "apolloColorBackgroundMiniTagOther4": "#fdeae8",
      "apolloColorStrokeButtonDefault": "#647893",
      "apolloColorTextDisabled": "#a8aebc",
      "apolloColorTextPopoverSecondary": "#d8dcea",
      "apolloBoxShadowContainer": "0px 1px 4px rgba(136, 136, 136, 0.08)",
      "apolloColorBackgroundVizRed": "#fdeae8",
      "apolloColorBackgroundVizValue": "#e8edf5",
      "apolloColorStrokeButtonTertiaryDefault": "#d9eaf5",
      "apolloColorBackgroundMainNav": "#08568a",
      "apolloColorVizStackedValue12": "#88bde6",
      "apolloColorStrokeContainer": "#e4e6f1",
      "apolloColorStrokeFilterHover": "#dfcea4",
      "apolloColorTextMiniTagOther4": "#523c3f",
      "apolloColorBackgroundMiniTagOther5": "#b5e0f6",
      "apolloColorBackgroundComponentToolbar": "#ffffff",
      "apolloColorBackgroundCalendar": "#f5f6fa",
      "apolloBoxShadowDialog": "0px 2px 24px rgba(139, 147, 166, 0.32)",
      "apolloBoxShadowSearch": "0px 24px 32px rgba(0, 0, 0, 0.4)",
      "apolloColorBackgroundSelectedOverlay": "rgba(93, 168, 236, 0.24)",
      "apolloColorBackgroundButtonPrimaryActive": "#0c5497",
      "apolloColorStrokeMessageError": "#fbdbd7",
      "apolloColorStrokeToggleDefault": "#647893",
      "apolloColorVizMapMarkerGreenDefault": "rgba(119, 194, 151, 0.72)",
      "apolloColorVizGreen": "#77c297",
      "apolloColorVizStackedValue13": "#4f82ae",
      "apolloColorTextMiniTagOther5": "#1b4064",
      "apolloColorBackgroundMiniTagOther6": "#dcc6d1",
      "apolloColorStrokeDialog": "#ffffff",
      "apolloColorBackgroundRightBarSecondaryItemSelected": "#647893",
      "apolloColorStrokeChartMarker": "#8b93a6",
      "apolloBoxShadowTooltip": "0px 4px 8px rgba(0, 0, 0, 0.24)",
      "apolloColorStrokeMainNavBarSeparator": "rgba(0, 0, 0, 0.2)",
      "apolloBoxShadowTooltip2ndLevel": "0px 4px 16px rgba(0, 0, 0, 0.4)",
      "apolloColorTextMiniTagOther6": "#473a3f",
      "apolloColorBackgroundMiniTagOther7": "#ccecef",
      "apolloColorStrokeFilterPresetHover": "#8b93a6",
      "apolloColorTextPrimaryInversed": "#ffffff",
      "apolloColorBackgroundFormElementReadonly": "#f5f6fa",
      "apolloColorBackgroundCollectionSelectorObjectDefault": "#e8edf5",
      "apolloColorFillFormElementDefault": "#e4e6f1",
      "apolloColorBackgroundChipDefault": "#f5f6fa",
      "apolloColorTextBullet3rdLevel": "#c4c9d4",
      "apolloColorBackgroundFormElementCheckedDisabled": "#fafafd",
      "apolloColorTextMiniTagOther7": "#384746",
      "apolloColorVizRedBackground": "#f4a297",
      "apolloBoxShadowHeader1stLevelDefault": "inset 0px 1px 0px rgba(216, 220, 234, 1), inset 0px -1px 0px rgba(250, 251, 253, 1)",
      "apolloColorBackgroundAssistantAnswerDefault": "#e4e6f1",
      "apolloColorBackgroundMainNavMenu": "#ffffff",
      "apolloColorStrokeSeparator": "#e4e6f1",
      "apolloColorStrokeMiniTileHover": "#c4c9d4",
      "apolloColorVizValueBackground": "#88bde6",
      "apolloColorBackgroundTooltipAlternate": "#f5f6fa",
      "apolloColorBackgroundMessageOk": "#edf7ee",
      "apolloColorBackgroundMiniTagBenchmark": "#00838e",
      "apolloColorVizBackgroundLightDefault": "#f5f6fa",
      "apolloColorVizYellowBackground": "#fedb95",
      "apolloColorBackgroundButtonSecondaryDisabled": "#f5f6fa",
      "apolloColorVizMapMarkerNeutralDefault": "rgba(112, 141, 190, 0.72)",
      "apolloColorStrokeInteractiveTagDisabled": "#d8dcea",
      "apolloColorBackgroundFormElementSelectedDisabled": "#91b0cc",
      "apolloBoxShadowMapMarkerHover": "0px 2px 0px rgba(0, 0, 0, 0.16)",
      "apolloColorBackgroundRightPanelHover": "#f5f6fa",
      "apolloColorBackgroundTableCellHover": "#f5f6fa",
      "apolloColorTextMiniTagBenchmark": "#ffffff",
      "apolloColorBackgroundFilterDisabled": "#f5f6fa",
      "apolloColorTextBullet2ndLevel": "#a7cde7",
      "apolloColorVizNoValueBackground": "#d8dcea",
      "apolloColorFillLoading": "linear-gradient(90deg, rgba(229, 241, 252, 1) 0%, rgba(93, 168, 236, 1) 50%, rgba(229, 241, 252, 1) 100%)",
      "apolloColorVizGreenThresholdBandBackground": "#edf7ee",
      "apolloColorBackgroundMainNavMenuOverlay": "rgba(88, 98, 125, 0.32)",
      "apolloColorStrokeRibbonSeparator": "#4f82ae",
      "apolloBoxShadowFormElementDisabled": "0px 1px 0px rgba(139, 147, 166, 0.08)",
      "apolloColorStrokeContainerSecondary": "#e4e6f1",
      "apolloColorStrokeError": "#f07e6e",
      "apolloColorStrokeFormElementDisabled": "#d8dcea",
      "apolloColorStrokeFilterPresetDefault": "#c4c9d4",
      "apolloColorBackgroundMainNavItemHover": "#1b4064",
      "apolloColorBackgroundSelectedLight": "#f1f7fc",
      "apolloColorBackgroundButtonSecondaryFocus": "#ffffff",
      "apolloColorVizMapMarkerGreenHoverFocus": "rgba(119, 194, 151, 0.72)",
      "apolloColorVizBackground": "#d8dcea",
      "apolloColorBackgroundMainNavItemSelected": "#5da8ec",
      "apolloBoxShadowRightPanelItemSelected": "inset 0px 1px 0px rgba(88, 98, 125, 0.24)",
      "apolloBoxShadowMainNavExpanded": "2px 0px 8px rgba(39, 45, 54, 0.24)",
      "apolloColorBackgroundMiniTagFilterPill": "#f4e8cc",
      "apolloColorTextPopoverDisabled": "#7d8186",
      "apolloColorStrokeHeader1stLevelSeparator": "#c4c9d4",
      "apolloColorVizInfo": "#88bde6",
      "apolloColorTextSecondary": "#58627d",
      "apolloColorVizUnknown": "#8b93a6",
      "apolloColorBackgroundFilterPreset": "#ffffff",
      "apolloColorBackgroundDashboard": "#f5f6fa",
      "apolloColorBackgroundButtonTertiaryActive": "#f1f7fc",
      "apolloColorStrokeChartDivider": "#c4c9d4",
      "apolloColorBackgroundPopoverHover": "#474e5a",
      "apolloColorTextMiniTagFilterPill": "#877336",
      "apolloColorStrokeFormElementHover": "#272d36",
      "apolloColorVizSelectionBackground": "rgba(93, 168, 236, 0.16)",
      "apolloColorStrokeButtonPrimarySeparatorDisabled": "#b5e0f6",
      "apolloColorStrokeChartAxis": "#c4c9d4",
      "apolloColorStrokeBlockDecoration": "#5da8ec",
      "apolloColorStrokeTableShading": "#e4e6f1",
      "apolloColorBackgroundTableCellDefault": "#ffffff",
      "apolloColorBackgroundTableCellSelected": "#f1f7fc",
      "apolloColorBackgroundRightPanelSelected": "#f5f6fa",
      "apolloColorStrokeMapMarkerDefault": "rgba(255, 255, 255, 0.72)",
      "apolloColorStrokeRightPanelTitleDecoration": "#88bde6",
      "apolloColorBackgroundToggleKnobDisabled": "#fafafd",
      "apolloColorVizMapMarkerNeutralHoverFocus": "rgba(112, 141, 190, 0.8)",
      "apolloColorVizGreenStrokeHover": "#6aaf88",
      "apolloColorBackgroundButtonSelected": "#0c6fc6",
      "apolloColorStrokeChipHighlighted": "#d9eaf5",
      "apolloColorStrokeMiniTag": "rgba(0, 0, 0, 0.04)",
      "apolloColorBackgroundMessageWarning": "#fbf8ec",
      "apolloColorBackgroundFormElementOpen": "#e4e6f1",
      "apolloColorBackgroundAssistantAnswerLast": "#d1ead9",
      "apolloColorBackgroundMiniTile": "#f5f6fa",
      "apolloColorBackgroundButtonSecondaryHover": "#ffffff",
      "apolloColorBackgroundDialog": "#ffffff"
},
    dark: {
      "apolloBoxShadowDropdownMenu": "0px 8px 24px rgba(15, 18, 22, 0.5), 0px 4px 4px rgba(0, 0, 0, 0.25)",
      "apolloBoxShadowSeparatorBottom": "inset 0px -1px 0px rgba(56, 62, 70, 1)",
      "apolloColorStrokeButtonPrimarySeparatorDefault": "#3d98cf",
      "apolloBoxShadowSeparatorTop": "inset 0px 1px 0px rgba(56, 62, 70, 1)",
      "apolloColorBackgroundMiniTagDisabled": "#272d36",
      "apolloColorBackgroundButtonTertiaryFocus": "#272d36",
      "apolloColorTextDisabledOnLight": "#93969b",
      "apolloColorTextPrimaryOnDark": "#ffffff",
      "apolloColorBackgroundContainerSideHighlight": "#163350",
      "apolloBoxShadowFormElementCheckedDisabled": "0px 1px 0px rgba(34, 39, 48, 1)",
      "apolloColorStrokeMessageInfo": "#a7cde7",
      "apolloColorVizGreenLineBackground": "linear-gradient(180deg, rgba(119, 194, 151, 0.2) 0%, rgba(119, 194, 151, 0) 100%)",
      "apolloColorFillCalendarSelectedEdge": "#0c6fc6",
      "apolloBoxShadowPanelScrolled": "inset 0px 1px 0px rgba(15, 18, 22, 0.8)",
      "apolloColorBackgroundDialogOverlay": "rgba(0, 0, 0, 0.5)",
      "apolloColorBackgroundBetaTag": "#52575e",
      "apolloColorTextPopoverPrimary": "#272d36",
      "apolloColorStrokeFormElementDefault": "#a8aebc",
      "apolloColorVizYellow": "#fdcd6c",
      "apolloColorBackgroundCollectionSelectorCategory": "#383e46",
      "apolloColorStrokeFocusOnDark": "#ffffff",
      "apolloColorBackgroundMiniTagNeutral": "#d9eaf5",
      "apolloColorStrokePopoverFocus": "#0c5497",
      "apolloColorVizRed": "#ec6054",
      "apolloColorBackgroundButtonSecondaryActive": "#474e5a",
      "apolloColorVizValue": "#88bde6",
      "apolloColorVizMapMarkerRedDefault": "rgba(240, 126, 110, 0.72)",
      "apolloColorBackgroundFormElementFocus": "#59606e",
      "apolloColorVizBackgroundLightSelected": "#272d36",
      "apolloBoxShadowPopoverFocus": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorFillScrollbar": "rgba(139, 147, 166, 0.5)",
      "apolloColorTextMiniTagNeutral": "#58627d",
      "apolloColorBackgroundHeader": "#272d36",
      "apolloColorBackgroundCalendarHover": "#647893",
      "apolloColorStrokeFilterDisabled": "#383e46",
      "apolloColorFillFormElementSelectedDisabled": "#93969b",
      "apolloColorTextBullet1stLevel": "#5da8ec",
      "apolloColorStrokeInteractiveTagDefault": "#4f5663",
      "apolloColorBackgroundButtonSecondaryDefault": "#272d36",
      "apolloColorBackgroundButtonTertiaryHover": "#191e24",
      "apolloColorFillFormElementSelected": "#ffffff",
      "apolloColorStrokeFilter": "#d3ae64",
      "apolloColorBackgroundCollectionSelectorObjectSelected": "#08568a",
      "apolloColorTextVizGreen": "#77c297",
      "apolloColorBackgroundHover": "#323740",
      "apolloBoxShadowDragged": "0px 4px 4px rgba(39, 45, 54, 0.16)",
      "apolloColorBackgroundFormElementCheckedDefault": "#0c6fc6",
      "apolloColorBackgroundTopNav2ndLevelSelected": "#383e46",
      "apolloColorVizGreenBackground": "#9dd3b4",
      "apolloColorBackgroundVizGreen": "#384746",
      "apolloColorBackgroundMainNavMenuHover": "#323740",
      "apolloColorVizYellowThresholdBandBackground": "#585242",
      "apolloColorBackgroundMainNavBarItemHover": "#1b4064",
      "apolloColorVizSelectionStroke": "#5da8ec",
      "apolloColorBackgroundFormElementHover": "#474e5a",
      "apolloColorFillCalendarSelected": "#5da8ec",
      "apolloBoxShadowFormElementChecked": "inset 0px 1px 0px rgba(51, 136, 213, 0.64), 0px 1px 0px rgba(29, 34, 41, 1)",
      "apolloBoxShadowRightPanelIssueSelected": "inset 4px 0px 0px rgba(93, 168, 236, 1)",
      "apolloColorStrokeToggleDisabled": "#3d434e",
      "apolloBoxShadowTabSelectedTop": "inset 0px 2px 0px rgba(93, 168, 236, 1)",
      "apolloColorStrokeSelected": "#5da8ec",
      "apolloColorVizValue2": "#a3537c",
      "apolloColorVizRedThresholdBandBackground": "#523c3f",
      "apolloColorBackgroundMainNavBar": "#0c5497",
      "apolloColorStrokeMessageWarning": "#fdcd6c",
      "apolloColorBackgroundButtonPrimaryFocus": "#0c6fc6",
      "apolloBoxShadowFormElementOpen": "inset 0px 1px 0px rgba(29, 34, 41, 1)",
      "apolloColorStrokeButtonTertiaryDisabled": "#383e46",
      "apolloColorBackgroundNumbered1stLevel": "#191e24",
      "apolloColorBackgroundChipHighlighted": "#374452",
      "apolloColorVizValue3": "#ddd27a",
      "apolloColorVizMapMarkerRedHoverFocus": "rgba(240, 126, 110, 0.8)",
      "apolloColorVizMapMarkerYellowDefault": "rgba(253, 205, 108, 0.72)",
      "apolloColorBackgroundToggleKnob": "#ffffff",
      "apolloColorBackgroundRightPanelItemDefault": "#383e46",
      "apolloColorTextDestructive": "#f18e7e",
      "apolloColorTextNumbered1stLevel": "#88bde6",
      "apolloColorTextPrimary": "#ffffff",
      "apolloColorBackgroundRightPanel": "#272d36",
      "apolloColorTextTertiary": "#d8dcea",
      "apolloColorBackgroundSummaryBannerIcon": "linear-gradient(180deg, rgba(56, 62, 70, 1) 0%, rgba(38, 44, 52, 1) 100%)",
      "apolloColorTextInteractive": "#5da8ec",
      "apolloColorVizValue4": "#e84d5f",
      "apolloColorBackgroundContainer": "#272d36",
      "apolloBoxShadowRightPanelItemOpened": "0px 1px 0px rgba(0, 0, 0, 0.08)",
      "apolloColorBackgroundButtonTertiaryDefault": "#272d36",
      "apolloColorBackgroundMessageInfo": "#272d36",
      "apolloColorBackgroundMenuItemHover": "#474e5a",
      "apolloColorTextPrimaryOnLight": "#272d36",
      "apolloColorStrokeFocus": "#ffffff",
      "apolloColorBackgroundButtonPrimaryDisabled": "#1b4064",
      "apolloColorTextDisabledOnDark": "#7d8186",
      "apolloColorVizValue5": "#b5bac6",
      "apolloColorBackgroundMessageError": "#272d36",
      "apolloColorFillWaiting": "#58627d",
      "apolloColorBackgroundTooltip": "#272d36",
      "apolloColorStrokeRightPanelSeparator": "#383e46",
      "apolloColorStrokeRightPanelSelectedSeparator": "#474e5a",
      "apolloColorBackgroundMenuItemSelected": "#0c6fc6",
      "apolloColorBackgroundFormElementDefault": "#59606e",
      "apolloColorBackgroundDialogProtectedArea": "#1d2229",
      "apolloColorVizValue6": "#d3b5f5",
      "apolloBoxShadowRightPanelItem": "0px 1px 0px rgba(0, 0, 0, 0.08)",
      "apolloColorStrokeAssistantDecoration": "#6c7076",
      "apolloColorStrokeMapMarkerDefault": "rgba(25, 30, 36, 0.72)",
      "apolloBoxShadowRightPanelSeparator": "inset 1px 0px 0px rgba(50, 55, 64, 1)",
      "apolloColorBackgroundHeaderUnfilteredDefault": "#52575e",
      "apolloColorVizBlueThresholdBandBackground": "#374452",
      "apolloColorBackgroundButtonPrimaryHover": "#0959a3",
      "apolloColorStrokeTableDivider": "#383e46",
      "apolloColorStrokeChipDefault": "#52575e",
      "apolloColorFillColorTagDisabled": "rgba(255, 255, 255, 0.12)",
      "apolloColorBackgroundMedia": "#474e5a",
      "apolloBoxShadowFormElement": "inset 0px 1px 0px rgba(255, 255, 255, 0.12), 0px 1px 0px rgba(29, 34, 41, 1)",
      "apolloColorVizYellowLineBackground": "linear-gradient(180deg, rgba(253, 205, 108, 0.2) 0%, rgba(253, 205, 108, 0) 100%)",
      "apolloColorBackgroundHeader1stLevel": "#3d434e",
      "apolloColorBackgroundContainerSideDefault": "#1d2229",
      "apolloBoxShadowFormElementFocusHighlight": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorBackgroundPopover": "#ffffff",
      "apolloColorStrokeButtonHover": "#ffffff",
      "apolloColorBackgroundTableCellSelectedHover": "#3d434e",
      "apolloColorStrokeMessageOk": "#77c297",
      "apolloColorStrokeHover": "#52575e",
      "apolloColorVizRedLineBackground": "linear-gradient(180deg, rgba(240, 126, 110, 0.2) 0%, rgba(240, 126, 110, 0) 100%)",
      "apolloColorVizPurpleThresholdBandBackground": "#3b3341",
      "apolloColorBackgroundHeaderUnfilteredSelected": "#52575e",
      "apolloColorVizValueLineBackground": "linear-gradient(180deg, rgba(136, 189, 230, 0.2) 0%, rgba(136, 189, 230, 0) 100%)",
      "apolloColorBackgroundFilter": "rgba(135, 115, 54, 0.2)",
      "apolloColorBackgroundRightBarBadge": "#d8dcea",
      "apolloColorFillTableGroupShadow": "linear-gradient(180deg, rgba(25, 30, 36, 0.4) 0%, rgba(39, 45, 54, 0) 100%)",
      "apolloColorVizBenchmark": "#19a4b0",
      "apolloColorBackgroundFormElementSelected": "#0c6fc6",
      "apolloColorStrokePopoverSeparator": "#e4e6f1",
      "apolloColorBackgroundMenuItemDefault": "#323740",
      "apolloColorBackgroundIconButtonHover": "#474e5a",
      "apolloColorTextRightPanelRank": "#8b93a6",
      "apolloColorVizMapMarkerYellowHoverFocus": "rgba(253, 205, 108, 0.8)",
      "apolloColorBackgroundMainNavBarItemSelected": "#0c6fc6",
      "apolloBoxShadowFormElementFocusOnDark": "0px 0px 0px rgba(0, 0, 0, 0)",
      "apolloColorTextError": "#f07e6e",
      "apolloColorBackgroundMiniTagOther1": "#fbdbd7",
      "apolloColorBackgroundRightPanelHeader": "#383e46",
      "apolloColorBackgroundFormElementDisabled": "#3d434e",
      "apolloColorBackgroundTopNav2ndLevelHover": "#383e46",
      "apolloColorBackgroundContainerHighlight": "#1b4064",
      "apolloColorVizValueStrokeHover": "#d9eaf5",
      "apolloColorBackgroundContainerSecondary": "#272d36",
      "apolloColorVizRedStrokeHover": "#fdeae8",
      "apolloColorVizYellowThresholdBandStroke": "#585242",
      "apolloColorTextMiniTagOther1": "#6f4645",
      "apolloColorBackgroundMiniTagOther2": "#fedb95",
      "apolloColorBackgroundIconKpiIcon": "rgba(0, 0, 0, 0.16)",
      "apolloColorStrokeMapMarkerHoverFocus": "#191e24",
      "apolloColorTextVizYellow": "#fdcd6c",
      "apolloColorBackgroundCollectionSelectorObjectHover": "#8b93a6",
      "apolloColorFillFormElementDefaultDisabled": "#3d434e",
      "apolloColorBackgroundRightPanelItemSelected": "#1d2229",
      "apolloColorBackgroundButtonPrimaryDefault": "#0c6fc6",
      "apolloColorVizRedThresholdBandStroke": "#6f4645",
      "apolloColorVizYellowStrokeHover": "#fbf8ec",
      "apolloColorBackgroundHourPicker": "rgba(25, 30, 36, 0.64)",
      "apolloColorStrokeFocusSecondary": "#272d36",
      "apolloColorTextMiniTagOther2": "#6f4645",
      "apolloColorBackgroundMiniTagOther3": "#d1ead9",
      "apolloColorBackgroundSelected": "#5da8ec",
      "apolloColorStrokeButtonTertiaryActive": "#383e46",
      "apolloColorTextVizRed": "#f18e7e",
      "apolloColorTextVizValue": "#88bde6",
      "apolloColorFillScrollbarHover": "#8b93a6",
      "apolloColorBackgroundButtonTertiaryDisabled": "#272d36",
      "apolloColorVizStackedValue11": "#b5e0f6",
      "apolloColorBackgroundHeaderHover": "#191e24",
      "apolloColorTextMiniTagOther3": "#384746",
      "apolloColorVizNoValueStrokeHover": "#f5f6fa",
      "apolloColorBackgroundMiniTagOther4": "#fdeae8",
      "apolloColorStrokeButtonDefault": "#a8aebc",
      "apolloColorTextDisabled": "#7d8186",
      "apolloColorTextPopoverSecondary": "#58627d",
      "apolloColorBackgroundVizRed": "#473a3f",
      "apolloColorBackgroundVizValue": "#374452",
      "apolloColorStrokeButtonTertiaryDefault": "#383e46",
      "apolloColorBackgroundMainNav": "#0c5497",
      "apolloColorVizStackedValue12": "#88bde6",
      "apolloColorStrokeContainer": "#272d36",
      "apolloColorStrokeFilterHover": "#dfcea4",
      "apolloColorTextMiniTagOther4": "#523c3f",
      "apolloColorBackgroundMiniTagOther5": "#b5e0f6",
      "apolloColorBackgroundComponentToolbar": "#323740",
      "apolloColorBackgroundCalendar": "#323740",
      "apolloBoxShadowDialog": "0px 8px 24px rgba(15, 18, 22, 0.5), 0px 4px 4px rgba(0, 0, 0, 0.25)",
      "apolloBoxShadowSearch": "0px 24px 32px rgba(0, 0, 0, 0.4)",
      "apolloColorBackgroundSelectedOverlay": "rgba(93, 168, 236, 0.24)",
      "apolloColorBackgroundButtonPrimaryActive": "#0c5497",
      "apolloColorStrokeMessageError": "#f18e7e",
      "apolloColorStrokeToggleDefault": "#a8aebc",
      "apolloColorVizMapMarkerGreenDefault": "rgba(119, 194, 151, 0.72)",
      "apolloColorVizGreen": "#77c297",
      "apolloColorVizStackedValue13": "#4f82ae",
      "apolloColorTextMiniTagOther5": "#1b4064",
      "apolloColorBackgroundMiniTagOther6": "#dcc6d1",
      "apolloColorStrokeDialog": "#383e46",
      "apolloColorBackgroundRightBarSecondaryItemSelected": "#8b93a6",
      "apolloColorStrokeChartMarker": "#8b93a6",
      "apolloBoxShadowTooltip": "0px 4px 8px rgba(0, 0, 0, 0.24)",
      "apolloColorStrokeMainNavBarSeparator": "rgba(0, 0, 0, 0.2)",
      "apolloBoxShadowTooltip2ndLevel": "0px 4px 16px rgba(0, 0, 0, 0.4)",
      "apolloColorTextMiniTagOther6": "#473a3f",
      "apolloColorBackgroundMiniTagOther7": "#ccecef",
      "apolloColorStrokeFilterPresetHover": "#8b93a6",
      "apolloColorTextPrimaryInversed": "#272d36",
      "apolloColorBackgroundFormElementReadonly": "#3d434e",
      "apolloColorBackgroundCollectionSelectorObjectDefault": "#272d36",
      "apolloColorFillFormElementDefault": "#59606e",
      "apolloColorBackgroundChipDefault": "#383e46",
      "apolloColorTextBullet3rdLevel": "#c4c9d4",
      "apolloColorBackgroundFormElementCheckedDisabled": "#1b4064",
      "apolloColorTextMiniTagOther7": "#384746",
      "apolloColorVizRedBackground": "#f4a297",
      "apolloColorBackgroundAssistantAnswerDefault": "#59606e",
      "apolloColorBackgroundMainNavMenu": "#272d36",
      "apolloColorStrokeSeparator": "rgba(255, 255, 255, 0.08)",
      "apolloColorStrokeMiniTileHover": "#52575e",
      "apolloColorVizValueBackground": "#88bde6",
      "apolloColorBackgroundTooltipAlternate": "#191e24",
      "apolloColorBackgroundMessageOk": "#272d36",
      "apolloColorBackgroundMiniTagBenchmark": "#00838e",
      "apolloColorVizBackgroundLightDefault": "#374452",
      "apolloColorVizYellowBackground": "#fedb95",
      "apolloColorBackgroundButtonSecondaryDisabled": "#383e46",
      "apolloColorVizMapMarkerNeutralDefault": "rgba(136, 189, 230, 0.72)",
      "apolloColorStrokeInteractiveTagDisabled": "#4f5663",
      "apolloColorBackgroundFormElementSelectedDisabled": "#1b4064",
      "apolloBoxShadowMapMarkerHover": "0px 2px 0px rgba(0, 0, 0, 0.16)",
      "apolloColorBackgroundRightPanelHover": "#323740",
      "apolloColorBackgroundTableCellHover": "#323740",
      "apolloColorTextMiniTagBenchmark": "#ffffff",
      "apolloColorBackgroundFilterDisabled": "#272d36",
      "apolloColorTextBullet2ndLevel": "#5da8ec",
      "apolloColorVizNoValueBackground": "#d8dcea",
      "apolloColorFillLoading": "linear-gradient(90deg, rgba(181, 224, 246, 1) 0%, rgba(93, 168, 236, 1) 50%, rgba(181, 224, 246, 1) 100%)",
      "apolloColorVizGreenThresholdBandBackground": "#384746",
      "apolloColorBackgroundMainNavMenuOverlay": "rgba(25, 30, 36, 0.64)",
      "apolloColorStrokeRibbonSeparator": "#4f82ae",
      "apolloBoxShadowFormElementDisabled": "0px 1px 0px rgba(34, 39, 48, 1)",
      "apolloColorStrokeError": "#f07e6e",
      "apolloColorStrokeFilterPresetDefault": "#4f5663",
      "apolloColorBackgroundMainNavItemHover": "#1b4064",
      "apolloColorBackgroundSelectedLight": "#3d434e",
      "apolloColorBackgroundButtonSecondaryFocus": "#272d36",
      "apolloColorVizMapMarkerGreenHoverFocus": "rgba(119, 194, 151, 0.8)",
      "apolloColorVizBackground": "rgba(255, 255, 255, 0.2)",
      "apolloColorBackgroundMainNavItemSelected": "#5da8ec",
      "apolloBoxShadowRightPanelItemSelected": "inset 0px 1px 0px rgba(25, 30, 36, 1)",
      "apolloBoxShadowMainNavExpanded": "2px 0px 8px rgba(39, 45, 54, 0.56)",
      "apolloColorBackgroundMiniTagFilterPill": "#877336",
      "apolloColorTextPopoverDisabled": "#a8aebc",
      "apolloColorStrokeHeader1stLevelSeparator": "#52575e",
      "apolloColorVizInfo": "#88bde6",
      "apolloColorTextSecondary": "#d8dcea",
      "apolloColorVizUnknown": "#8b93a6",
      "apolloColorBackgroundFilterPreset": "#272d36",
      "apolloColorBackgroundDashboard": "#191e24",
      "apolloColorBackgroundButtonTertiaryActive": "#191e24",
      "apolloColorStrokeChartDivider": "rgba(255, 255, 255, 0.2)",
      "apolloColorBackgroundPopoverHover": "#eff0f4",
      "apolloColorTextMiniTagFilterPill": "#fffcf2",
      "apolloColorStrokeFormElementHover": "#ffffff",
      "apolloColorVizSelectionBackground": "rgba(93, 168, 236, 0.16)",
      "apolloColorStrokeButtonPrimarySeparatorDisabled": "#295e8b",
      "apolloColorStrokeChartAxis": "rgba(255, 255, 255, 0.2)",
      "apolloColorStrokeBlockDecoration": "#5da8ec",
      "apolloColorStrokeTableShading": "#59606e",
      "apolloColorBackgroundTableCellDefault": "#272d36",
      "apolloColorBackgroundTableCellSelected": "#3d434e",
      "apolloColorBackgroundRightPanelSelected": "#323740",
      "apolloColorStrokeRightPanelTitleDecoration": "#88bde6",
      "apolloColorBackgroundToggleKnobDisabled": "#5d6268",
      "apolloColorVizMapMarkerNeutralHoverFocus": "rgba(136, 189, 230, 0.8)",
      "apolloColorVizGreenStrokeHover": "#edf7ee",
      "apolloColorBackgroundButtonSelected": "#0c6fc6",
      "apolloColorStrokeChipHighlighted": "#4f82ae",
      "apolloColorStrokeMiniTag": "rgba(255, 255, 255, 0.08)",
      "apolloColorBackgroundMessageWarning": "#272d36",
      "apolloColorBackgroundFormElementOpen": "#474e5a",
      "apolloColorBackgroundAssistantAnswerLast": "#377b56",
      "apolloColorBackgroundMiniTile": "#191e24",
      "apolloColorBackgroundButtonSecondaryHover": "#272d36",
      "apolloColorBackgroundDialog": "#272d36"
},
  },
};